import React from 'react'
import { VictoryPie } from 'victory'
import PropTypes from 'prop-types'
export default class PieChar extends React.Component {
  render () {
    let width = parseInt(this.props.width) || 300
    let height = parseInt(this.props.height) || 300
    const { bienestar, malestar } = this.props.vector
    const data = [
      {x: ` ${Math.round(malestar)}%`, y: malestar},
      {x: ` ${Math.round(bienestar)}%`, y: bienestar}
    ]
    let size = width * 27 / 300
    return (
      <div id='AfectoPie'>
          <svg style={{ parent: { maxWidth: '50%' } }} width={width} height={height}>
            <VictoryPie style={{ data: { stroke: 'white', strokeWidth: 1 }, labels: { fill: 'white', fontSize: size } }}
            width={width} height={height}
            labelRadius={40}
            colorScale={[ '#C61F28', '#00678E' ]} data={data}></VictoryPie>
          </svg>
          <br></br>
          <div className='legend-pie'>
            <div className='b-blue'></div> <div>Bienestar </div>
            <div className='m-red'></div> <div>Malestar </div>
          </div>
      </div>
    )
  }
}
PieChar.propTypes = {
  vector: PropTypes.object,
  width: PropTypes.any,
  height: PropTypes.any
}



// WEBPACK FOOTER //
// ./src/components/Patient/Component/PieChar.js